import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDe = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 5 3",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("desc", { children: "Flag of Germany" }),
		/* @__PURE__ */ _jsx("rect", {
			id: "black_stripe",
			width: 5,
			height: 3,
			y: 0,
			x: 0,
			fill: "#000"
		}),
		/* @__PURE__ */ _jsx("rect", {
			id: "red_stripe",
			width: 5,
			height: 2,
			y: 1,
			x: 0,
			fill: "#D00"
		}),
		/* @__PURE__ */ _jsx("rect", {
			id: "gold_stripe",
			width: 5,
			height: 1,
			y: 2,
			x: 0,
			fill: "#FFCE00"
		})
	]
});
export default SvgDe;
